<template>
  <v-card flat style="height: 100%;">
    <v-container fluid grid-list-md fill-height style="padding:0px;width:100%;">
      <v-layout row fill-height>
        <v-flex d-flex md12>
          <v-layout column fill-height>
            <v-flex d-flex md4 style="padding-bottom: 0; max-height: 70vh">
              <v-card flat style="">
                <v-card-title>
                  <v-container grid-list-md>
                    <v-layout column>
                      <div style="padding:5px; font-size: 32px !important;
                                                            font-weight: 500; line-height: 1 !important;letter-spacing: 0.02em !important; color:rgb(51,82,128);">WiDE - WinGD Integrated Digital Expert
                      </div>
                      <div style="padding:5px; font-size: 16px !important; font-weight: 500; line-height: 1 !important;letter-spacing: 0.02em !important; color:rgb(115, 115, 115);">Creating value from engine and ship data</div>
                    </v-layout>
                  </v-container>
                </v-card-title>
                <v-card-text :style="'padding-top:' + padding_top + '%; padding-bottom: 0'">
                  <v-container grid-list-md>
                    <v-layout column>
                      <v-flex style="max-height: calc(100% / 12 * 2)">
                        <v-text-field v-model="email" label="Email"></v-text-field>
                      </v-flex>
                      <v-flex style="max-height: calc(100% / 12 * 2)">
                        <v-text-field v-model="password" :append-icon="show ? 'visibility' : 'visibility_off'" :type="show ? 'text' : 'password'" label="Password" @click:append="show = !show"></v-text-field>
                      </v-flex>
                      <v-flex style="max-height: calc(100% / 12 * 3)">
                        <v-btn style="color:white; background-color: rgb(51,82,128); width: 100%; margin-left: 0;" flat @click="userLogin()">Login</v-btn>
                      </v-flex>
                      <v-flex style="max-height: calc(100% / 12 * 2)">
                        <div style="height: 1rem;display: flex;flex-grow: 1;flex-direction: column;width: 100%;position: relative;justify-content: center;align-items: center;">
                          <hr style="width: 100%;">
                          <div id="loginInfoHolder">
                            or login with
                          </div>
                        </div>
                        <v-btn style="color:white; background-color: rgb(51,82,128); width: 100%; margin-left: 0;" flat @click="cognitoLogin()">Other Identity Provider</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-alert
                    id="loginAlertContainer"
                    class='alert'
                    :value="alert"
                    type="error"
                    transition="scale-transition"
                    color='rgb(205, 57, 64)'
                    outline dismissible
                    @input="closeAlert"
                >
                  <pre ref="alertTextDisplay" style="font-family: inherit;">{{ ((customAlert == '') ? 'The email and password you entered are not correct.' : customAlert) }}</pre>
                </v-alert>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>

import axios from 'axios'
import {globalStore, vessels} from "../main.js"

export default {
  name: "Login",
  components: {},
  data() {
    return {
      email: '',
      password: '',
      padding_top: ((window.screen.orientation.type.indexOf('portrait') > -1) ? 20 : 0),
      show: false,
      alert: false
    }
  },
  created() {

  },
  mounted() {
    window.addEventListener(
        "orientationchange",
        this.handleOrientationChange
    );

    this.handleOrientationChange
  },
  methods: {
    closeAlert(v) {
      this.alert = false;
    },
    userLogin() {
      if (this.password.length <= 0) {
        this.alert = true;
      } else {
        axios.post(globalStore.config.api_location + '/login', {email: this.email.trim(), password: this.password.trim(),}, {headers: {Authorization: globalStore.auth_token}})
            .then(
                async (response) => {
                  if (response.status === 200) {
                    this.profile = response.data;

                    globalStore.auth_token = this.profile.jwt;

                    vessels.vessels = Object.assign({}, this.profile.vessels);
                    await localStorage.setItem('vessels', JSON.stringify(this.profile.vessels));

                    globalStore.alertFilters = Object.assign({}, this.profile.rules);
                    await localStorage.setItem('alertFilters', JSON.stringify(globalStore.alertFilters));
                    window.$cookies.set('alertCheck', true);

                    globalStore.alerts = this.profile.notifications;
                    await localStorage.setItem('alerts', JSON.stringify(this.profile.notifications));

                    delete this.profile.vessels;
                    delete this.profile.rules;
                    delete this.profile.notifications;

                    globalStore.userProfile = this.profile;
                    globalStore.userLogged = true;

                    window.$cookies.set('user', globalStore.userProfile);

                    if (globalStore.requestedBeforeLogin.length) {
                      this.$router.push((new URL(globalStore.requestedBeforeLogin)).pathname.toString())
                    } else {
                      this.$router.push({path: 'dashboard'});
                    }
                  } else {
                    this.alert = true;
                  }
                },
                (error) => {
                  this.alert = true;
                }
            );
      }
    },
    cognitoLogin() {
      location = `${globalStore.config.api_location}/cognito`
    },
    loginWithCognitoCode() {
      let params = {withCredentials: false};

      axios.post(globalStore.config.api_location + '/cognito_login', {cognito_code: localStorage.cognito_code}, params)
          .then(
              async (response) => {
                localStorage.setItem('cognito_code', null);

                if (response.status === 200) {
                  this.profile = response.data;

                  globalStore.auth_token = this.profile.jwt;

                  vessels.vessels = Object.assign([], this.profile.vessels);
                  await localStorage.setItem('vessels', JSON.stringify(this.profile.vessels));

                  globalStore.alertFilters = Object.assign({}, this.profile.rules);
                  await localStorage.setItem('alertFilters', JSON.stringify(globalStore.alertFilters));
                  window.$cookies.set('alertCheck', true);

                  globalStore.alerts = this.profile.notifications;
                  await localStorage.setItem('alerts', JSON.stringify(this.profile.notifications));

                  delete this.profile.vessels;
                  delete this.profile.rules;
                  delete this.profile.notifications;

                  globalStore.userProfile = this.profile;
                  globalStore.userLogged = true;

                  window.$cookies.set('user', globalStore.userProfile);

                  if (globalStore.requestedBeforeLogin.length) {
                    this.$router.push((new URL(globalStore.requestedBeforeLogin)).pathname.toString())
                  } else {
                    this.$router.push({path: 'dashboard'});
                  }
                } else {
                  this.alert = true;
                }
              },
              (error) => {
                localStorage.setItem('cognito_code', null);

                if (error.response.data.error == 'Cognito user not found') {
                  this.$refs['alertTextDisplay'].innerHTML = this.cognito_msg;
                } else {
                  this.customAlert = error.response.data.error;
                }
                this.alert = true;
              }
          );
    },
    handleOrientationChange() {
      if (window.screen.orientation.type.indexOf('portrait') > -1) {
        return this.padding_top = 20;
      } else {
        return this.padding_top = 0;
      }
    },
    redirectToProvider() {
      let provider = localStorage.requested_provider;
      localStorage.setItem('requested_provider', null);
      location = `${globalStore.config.api_location}/identity_providers/redirect_to/${provider}`
    },
    handleLoginError() {
      let login_error = localStorage.login_error;
      localStorage.setItem('login_error', null);

      this.customAlert = login_error;
      this.alert = true;
    }
  },
  computed: {
    api_location: function () {
      return globalStore.config.api_location;
    }
  },
  watch: {
    api_location: function (location) {
      if (!!location && typeof location != 'undefined') {
        if (!window.$cookies.isKey('user') && !!localStorage.cognito_code && localStorage.cognito_code != 'null') {
          this.loginWithCognitoCode()
        } else if (!window.$cookies.isKey('user') && !!localStorage.requested_provider && localStorage.requested_provider != 'null') {
          this.redirectToProvider()
        } else if (!window.$cookies.isKey('user') && !!localStorage.login_error && localStorage.login_error != 'null') {
          this.handleLoginError()
        }
      }
    }
  }
}
</script>

<style>
#loginAlertContainer {
  min-width: 35rem;
  text-align: center;
}

#loginInfoHolder {
  position: absolute;
  display: flex;
  background: white;
  padding: 0 8px;
  text-align: center;
  align-items: center;
}

#loginInfoHolder svg {
  border: 1px solid black;
  line-height: 8px;
  height: 8px;
  width: 8px;
  border-radius: 16px;
  padding: 3px;
  margin-left: 6px;
  font-size: 8px;
}
</style>

<style scoped>

</style>
